module.exports = __webpack_public_path__ + "img/王立刚.08d7f792.jpg";